






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
class BSwitch extends Vue {
  @Prop({ type: Boolean, default: false }) checked!: boolean;
  @Prop({ type: String, default: null }) parent!: string;
  @Prop({ type: String, default: "" }) variant!: string;
  check = this.checked;

  @Watch("checked")
  updateChack(): void {
    this.check = this.checked;
  }
}
export default BSwitch;
